import { Box, TextField, Typography, Divider, InputAdornment } from "@mui/material";
import {
  Email as EmailIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  Lock as LockIcon,
} from "@mui/icons-material";
import MaskedInput from "../../components/MaskedInput";

const UserForm = ({ formData, errors, handleChange }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        Dados do Usuário
      </Typography>
      <Divider sx={{ mb: 3 }} />
      
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Box sx={{ display: "flex", gap: 2, flexDirection: { xs: "column", md: "row" } }}>
          <TextField
            fullWidth
            label="Nome Completo *"
            value={formData.userData.name}
            onChange={(e) => handleChange("name", e.target.value, true)}
            error={!!errors.userName}
            helperText={errors.userName}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
          />
          
          <TextField
            fullWidth
            label="Email *"
            type="email"
            value={formData.userData.email}
            onChange={(e) => handleChange("email", e.target.value, true)}
            error={!!errors.email}
            helperText={errors.email}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        
        <Box sx={{ display: "flex", gap: 2, flexDirection: { xs: "column", md: "row" } }}>
          <MaskedInput
            mask="(99) 99999-9999"
            label="Telefone *"
            value={formData.userData.phone}
            onChange={(e) => handleChange("phone", e.target.value, true)}
            error={!!errors.phone}
            helperText={errors.phone}
            placeholder="(11) 99999-9999"
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PhoneIcon />
                </InputAdornment>
              ),
            }}
          />
          
          <TextField
            fullWidth
            label="Senha *"
            type="password"
            value={formData.userData.password}
            onChange={(e) => handleChange("password", e.target.value, true)}
            error={!!errors.password}
            helperText={errors.password}
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default UserForm;